import { useEffect, useReducer, useState } from "react";
import moment from "moment";

import * as actions from "../../../actions/schAttainment";
import schAttainmentReducer from "../../../reducers/schAttainment";

import DailyInput from "./DailyInput";
import RunChart from "./RunChart";
import ParetoChart from "./ParetoChart";
import ExportDataFilters from "./ExportDataFilters";
import { postUserLog } from "../../../actions/common";

const initState = { shiftDetails: null };

const ScheduleAttainment = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDailyInputOpen, setIsDailyInputOpen] = useState(false);
  const [showExportForm, setShowExportForm] = useState(false);
  const [isRefreshDataRequired, setIsRefreshDataRequired] = useState(false);

  const { tierId, schAttainmentFlag, andon, siteId, navigationOn } = props;

  const [state, dispatch] = useReducer(schAttainmentReducer, initState);

  const { shiftDetails } = state;

  useEffect(() => {
    actions.fetchDailyInputTarget(
      dispatch,
      `${tierId}&type=SA&date=${moment().format("YYYY-MM-DD")}`
    );
  }, []);

  useEffect(() => {
    if (!isDailyInputOpen) {
      andon();
    }
  }, [isDailyInputOpen]);

  return (
    <>
      <div
        className="col-heading"
        style={{
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "inline-block",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            Delivery Metric : Schedule Attainment
            <span
              className={schAttainmentFlag}
              style={{ marginLeft: "10px" }}
            ></span>
          </div>
        </div>

        <div
          style={{
            float: "right",
          }}
        >
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setShowExportForm(!showExportForm);
              postUserLog({
                event: "Run Chart Export",
                data: {
                  action: "Export clicked",
                  module: "Digital Tier",
                  section: navigationOn,
                  siteUId: siteId,
                  tierId: tierId,
                  widget: "Delivery Metric: Schedule Attainment",
                },
              });
            }}
          >
            <i class="fas fa-file-export" style={{ marginRight: "5px" }}></i>
            Export
          </span>

          <span
            style={{
              marginLeft: "10px",
              cursor: "pointer",
            }}
          >
            {isCollapsed ? (
              <i
                className="fas fa-chevron-down"
                onClick={() => {
                  setIsCollapsed(!isCollapsed);
                  postUserLog({
                    event: "Widget Expand",
                    data: {
                      action: "Widget was expanded",
                      module: "Digital Tier",
                      section: navigationOn,
                      siteUId: siteId,
                      widget: "Delivery Metric: Schedule Attainment",
                      tierId: tierId,
                    },
                  });
                }}
                title="Expand"
              ></i>
            ) : (
              <i
                className="fas fa-chevron-up"
                onClick={() => {
                  setIsCollapsed(!isCollapsed);
                  postUserLog({
                    event: "Widget Collapse",
                    data: {
                      action: "Widget was collapsed",
                      module: "Digital Tier",
                      section: navigationOn,
                      siteUId: siteId,
                      widget: "Delivery Metric: Schedule Attainment",
                      tierId: tierId,
                    },
                  });
                }}
                title="Collapse"
              ></i>
            )}
          </span>
        </div>
      </div>

      {!isCollapsed && (
        <div className="col-body">
          {showExportForm && (
            <ExportDataFilters
              tierId={tierId}
              showExportForm={setShowExportForm}
              shiftDetails={shiftDetails}
              navigationOn={navigationOn}
            />
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div>Target {shiftDetails?.target}%</div>
            <div
              style={{
                marginLeft: "10px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={() => setIsDailyInputOpen(true)}
            >
              <i className="fas fa-plus-circle" title="Daily Input"></i>
            </div>
          </div>

          <div
            style={{
              margin: "10px 0",
            }}
          >
            <RunChart
              tierId={tierId}
              isRefreshDataRequired={isRefreshDataRequired}
            />
          </div>
          <div
            style={{
              margin: "10px 0px",
            }}
          >
            <ParetoChart
              tierId={tierId}
              isRefreshDataRequired={isRefreshDataRequired}
            />
          </div>
        </div>
      )}

      {isDailyInputOpen && (
        <DailyInput
          open={isDailyInputOpen}
          close={setIsDailyInputOpen}
          shiftDetails={shiftDetails}
          tierId={tierId}
          isRefreshDataRequired={isRefreshDataRequired}
          setIsRefreshDataRequired={setIsRefreshDataRequired}
          siteId={siteId}
          navigationOn={navigationOn}
        />
      )}
    </>
  );
};

export default ScheduleAttainment;
